import { render, staticRenderFns } from "./AudioReadOnly.vue?vue&type=template&id=0bebbab6&"
import script from "./AudioReadOnly.vue?vue&type=script&lang=js&"
export * from "./AudioReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports